<div class="section-inputs">
  <mat-form-field class="full-width" appearance="outline">
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      [formControl]="control"
      [placeholder]="label"
      [matDatepicker]="picker"
      [max]="useMaxDate ? maxDate || today : null"
      [matDatepickerFilter]="dateFilter"
      [maskito]="dateMask"
    />
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker [calendarHeaderComponent]="datePickerHeader"></mat-datepicker>
    <mat-error
      *ngIf="
        (control.hasError('required') || control.hasError('matDatepickerParse')) &&
        (control.touched || control.dirty)
      "
    >
      {{ errorMessages.required }}
    </mat-error>
  </mat-form-field>
</div>
